import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function SellerSignup() {
  const [form, setForm] = useState({ name: "", phone: "", email: "", password: "" });
  const navigate = useNavigate();

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    const res = await axios.post("https://haaterkaj-backend-1.onrender.com/api/seller/signup", form);
    if (res.data.success) navigate("/seller-login");
  };

  return (
    <div className="max-w-md mx-auto mt-10 p-6 border rounded shadow">
      <h2 className="text-2xl font-bold mb-4">Seller Signup</h2>
      <form onSubmit={handleSubmit} className="space-y-3">
        <input name="name" placeholder="Name" className="w-full border p-2 text-black placeholder-gray-600" onChange={handleChange} />
        <input name="phone" placeholder="Phone" className="w-full border p-2 text-black placeholder-gray-600" onChange={handleChange} />
        <input name="email" placeholder="Email" className="w-full border p-2 text-black placeholder-gray-600" onChange={handleChange} />
        <input name="password" type="password" placeholder="Password" className="w-full border p-2 text-black placeholder-gray-600" onChange={handleChange} />
        <button className="bg-amber-700 text-white px-4 py-2 rounded w-full">Signup</button>
      </form>
    </div>
  );
}
